
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/d/account/plan",
      function () {
        return require("private-next-pages/d/account/plan/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/d/account/plan"])
      });
    }
  